import anime from 'animejs';


export default function InitStyleElements() {
	const styleElements = document.querySelectorAll('.bard__module.style_element img');
	if (styleElements.length === 0) return;
	let previousY = [];

	document.addEventListener('scroll', (event) => {
		styleElements.forEach((styleElement, index) => {
			const currentY = styleElement.getBoundingClientRect().y;

			let isRightBound = styleElement.classList.contains('right');
			let rotationDirection = isRightBound ? "-=" : "+=";
			let offset = currentY - previousY[index];

			anime({
				targets: styleElement,
				rotate: `${rotationDirection}${offset / 5}`,
				easing: "easeInSine",
				duration: "0ms"
			});

			previousY[index] = currentY;
		});
	});
}
